<template>
  <section>
    <div v-if="$store.state.user">
      <DashboardSpinner />
    </div>

    <div v-else>
      <HomeAnonymous />
    </div>

    <div v-if="showDialog">
      <EmailConfirmationPopUp :show="showDialog" />
    </div>

    <div v-if="showDialogInvalid">
      <Invalid :show="showDialogInvalid" />
    </div>
  </section>
</template>

<script>
import DashboardSpinner from '../components/DashboardSpinner'
import HomeAnonymous from '../components/Anonymous'
import EmailConfirmationPopUp from '../components/EmailConfirmation'
import Invalid from '../components/InvalidPopUp'
import { ampli } from '@/mixins/Amplitude'

export default {
  components: {
    HomeAnonymous,
    DashboardSpinner,
    EmailConfirmationPopUp,
    Invalid,
  },
  mixins: [ampli],

  head() {
    const title = this.$store.state.user
      ? 'Überblicken | Lernpfad'
      : 'Lernen einfach strukturiert | Lernpfad'
    return {
      title,
    }
  },

  computed: {
    dataReady() {
      return !this.$store.state.user
    },
    showDialog() {
      // http://localhost:3000/?showdialog
      return typeof this.$route.query.showdialog !== 'undefined'
    },
    showDialogInvalid() {
      return typeof this.$route.query.showdialoginvalid !== 'undefined'
    },
  },
}
</script>

<style
  scoped
  lang="scss"
></style>
